var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sp-grid',{ref:"paycheck-grid",attrs:{"unique":"id","fields":_vm.columns,"items":_vm.parsedPaychecks,"busy":_vm.loading,"canPaginate":true,"totalElements":_vm.totalElements},on:{"viewAction":_vm.onView,"printAction":_vm.onPrint}})}
var staticRenderFns = []

export { render, staticRenderFns }